import React from "react";
import PropTypes from "prop-types";
import { constants } from "@qgiv/core-js";
import { useDispatch, useSelector } from "react-redux";
import { useFormikContext } from "formik";
import { fieldsToSetWithClassificationSelection } from "@qgiv/p2p-registration";
import { selectCmsControlByIdByPage } from "../../../redux/slices/cmsSettingsSlice";
import { selectIsCms } from "../../../redux/slices/configSlice";
import {
    selectAllRegistration,
    updateCategoryOnRegistrations,
    updateCurrentRegistration,
    updateRegistration,
} from "../../../redux/slices/registrationSlice";
import { selectAllClassifications } from "../../../redux/slices/classificationsSlice";
import { selectTeams } from "../../../redux/slices/teamsSlice";
import Submit from "./Submit";
import { selectAllP2pSettings } from "../../../redux/slices/p2pSettingsSlice";
import { selectAllCategories } from "../../../redux/slices/categoriesSlice";

const ConnectedSubmit = ({ controlId }) => {
    const {
        ENUMS: { DefaultView },
    } = constants;

    const dispatch = useDispatch();

    const { values } = useFormikContext();

    const isCms = useSelector(selectIsCms);
    const {
        registrations,
        classification: { Classification = [] },
    } = useSelector(selectAllRegistration);
    const teams = useSelector(selectTeams);
    const p2pSettings = useSelector(selectAllP2pSettings);
    const { limitTeamJoiningToClassification } = p2pSettings;
    const categories = useSelector(selectAllCategories);

    const classifications = useSelector(selectAllClassifications);

    const control = useSelector((state) =>
        selectCmsControlByIdByPage(
            controlId,
            DefaultView.REGISTRATION_CLASSIFICATION_STEP,
            state,
        ),
    );

    const {
        options: { nextButtonLabel = "Next" },
    } = control;

    const handleClassificationSubmit = (e) => {
        const hasSelectedNewClassification =
            values.Classification[0] !== Classification[0];

        // we do not want to submit anything in cms view
        if (isCms) {
            e.preventDefault();
            return;
        }
        if (registrations.length === 0 || !hasSelectedNewClassification) return;

        registrations.forEach((registration, index) => {
            const {
                newCategoryValueToSet,
                newRegistrationValuesToSet,
                shouldResetCategory,
                shouldResetData,
            } = fieldsToSetWithClassificationSelection({
                categories,
                classifications,
                limitTeamJoiningToClassification,
                registration,
                teams,
                values,
            });

            if (shouldResetData) {
                dispatch(
                    updateRegistration({
                        index,
                        registration: newRegistrationValuesToSet,
                    }),
                );
            }
            if (shouldResetCategory) {
                dispatch(
                    updateCategoryOnRegistrations({
                        index,
                        Category: newCategoryValueToSet,
                    }),
                );
                dispatch(
                    updateRegistration({
                        index,
                        registration: { Needs_To_Be_Reviewed: true },
                    }),
                );
            }
            if (shouldResetData || shouldResetCategory) {
                dispatch(updateCurrentRegistration(0));
            }
        });
    };

    return (
        <Submit
            nextButtonLabel={nextButtonLabel}
            handleClassificationSubmit={handleClassificationSubmit}
        />
    );
};

ConnectedSubmit.propTypes = {
    controlId: PropTypes.number.isRequired,
};

export default ConnectedSubmit;
